import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from "./redux/store";

import App from './components/App';

//Development-only. Axios helpers
import axios from 'axios';
window.axios = axios;

// Expose store for debugging
window.store = store;

const container = document.querySelector('#root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
